import {Component, OnInit, HostListener, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
import {NewsService} from "../../../shared/services/news.service";
import {NgModel} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {BlogService} from "../../../shared/services/blog.service";
import Swal from 'sweetalert2';
import {Router} from "@angular/router";
import {AlumniService} from "../../../shared/services/alumni.service";
import {TestimonialService} from "../../../shared/services/testimonial.service";

declare var bootstrap: any;
declare var $: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
    newsData: any;
    noticeData: any;
    alumni: any;
    testimonials: any;
    @ViewChild('news') private News: ElementRef;

    ngAfterViewInit(): void {
        const carouselElement = document.getElementById('carouselExampleIndicators');
        if (carouselElement) {
            const carousel = new bootstrap.Carousel(carouselElement, {
                interval: 5000, // Set the autoplay interval
                ride: 'carousel' // Enable autoplay
            });
        }

        // const testimonialCarousel = document.getElementById('carouselExampleIndicators1');
        // if (testimonialCarousel) {
        //     const carousel1 = new bootstrap.Carousel(testimonialCarousel, {
        //         interval: 5000, // Set the autoplay interval
        //         ride: 'carousel' // Enable autoplay
        //     });
        // }

        const carouselExampleIndicatorsPlacement = document.getElementById('carouselExampleIndicatorsPlacement');
        if (carouselExampleIndicatorsPlacement) {
            const carousel2 = new bootstrap.Carousel(carouselExampleIndicatorsPlacement, {
                interval: 5000, // Set the autoplay interval
                ride: 'carousel' // Enable autoplay
            });
        }

        const carouselExampleIndicatorsSchools = document.getElementById('carouselExampleIndicatorsSchools');
        if (carouselExampleIndicatorsSchools) {
            const carousel2 = new bootstrap.Carousel(carouselExampleIndicatorsSchools, {
                interval: 5000, // Set the autoplay interval
                ride: 'carousel' // Enable autoplay
            });
        }

        const carouselExampleIndicatorsTestimonial = document.getElementById('carouselExampleIndicatorsTestimonial');
        if (carouselExampleIndicatorsTestimonial) {
            const carousel2 = new bootstrap.Carousel(carouselExampleIndicatorsTestimonial, {
                interval: 5000, // Set the autoplay interval
                ride: 'carousel' // Enable autoplay
            });
        }
    }

    constructor(private newsService: NewsService,
                private modelService: NgbModal,
                private blogService: BlogService,
                private alumniService: AlumniService,
                private testimonialService: TestimonialService,
                private router: Router) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
        this.getNews();
    }

    getNews(): void {
        this.newsService.get({status: 'ACTIVE', page: 1, per_page: 3}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.newsData = data['data'];
                // this.openModal();
            }
        });

        this.getNotice();
    }

    getNotice(): void {
        this.blogService.get({status: 'ACTIVE', page: 1, per_page: 10}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.noticeData = data['data'];
            }
        });
        this.getAlumni();
    }

    getAlumni() {
        this.alumniService.get({status: 'ACTIVE'}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.alumni = data['data'];
                if ((this.alumni[this.alumni.length - 1]?.length) == 1) {
                    this.alumni[this.alumni.length - 1] = [...this.alumni[this.alumni.length - 1], this.alumni[0][0]];
                }
            }
        });
        this.getTestimonial();
    }

    getTestimonial() {
        this.testimonialService.get().subscribe(data => {
            console.log(data);
            if (data && data['data'].length > 0) {
                this.testimonials = data['data'];
                console.log(this.testimonials);
                if ((this.testimonials[this.testimonials.length - 1]?.length) == 1) {
                    this.testimonials[this.testimonials.length - 1] = [...this.testimonials[this.testimonials.length - 1], this.testimonials[0][0],this.testimonials[0][1]];
                }else if ((this.testimonials[this.testimonials.length - 1]?.length) == 2) {
                    this.testimonials[this.testimonials.length - 1] = [...this.testimonials[this.testimonials.length - 1], this.testimonials[0][0]];
                }
                console.log(this.testimonials);
            }
        })
    }

    openModal() {
        const goToUrl = (url: any) => {
            this.router.navigateByUrl(url);
        };
        this.modelService.open(this.News, {size: 'lg'});
        // Swal.fire({
        //     title: "Latest Information",
        //     html: `
        //            <h5 class="text-secondary">Admission Helpline No. <a href="tel:9015909622">9015909622</a></h5>
        //            <a href="enquiry" target="_blank"><button class="btn btn-lg btn-info">APPLY ADMISSION ENQUIRY 2024</button></a>
        //            <a href="https://arni.in/Conference/ICCDGC2024.aspx" target="_blank"><button class="btn btn-lg btn-info">INTERNATIONAL CONFERENCE</button></a>
        //     `,
        //     text: "Modal with a custom image.",
        //     imageUrl: "assets/img/popup_image.jpg",
        //     imageWidth: 850,
        //     imageHeight: 400,
        //     heightAuto: true,
        //     width: 900,
        //     imageAlt: "Custom image",
        // });
    }

    closeModal() {
        this.modelService.dismissAll();
    }

    goTo(url: any) {
        window.open(url, '_blank');
    }

    goToUrl(url: any) {
        this.router.navigateByUrl(url);
    }


}
